export const Config = {
  apiUrl: window.location.origin,
   // reCAPTCHASiteKey: "6Le6wq0qAAAAAHGvRt3HfKUxeQOZP0gRKXBiaYAU",//local
   // reCAPTCHASiteKey: "6Lc9YK8qAAAAADh9lO4wWPm7BGI67gtXCMu1BeFD"//dev
    reCAPTCHASiteKey: "6Le8iK8qAAAAAAFRN9bfkCjUlbYXWO6gO7DuUuh2" //Prod

};


